<template>
    <v-list dense class="solis-menu pa-2">
        <template v-for="(page, i) in nodes">
            <!-- Item sem filhos -->
            <v-list-item v-if="page.children.length === 0" :key="i" :to="page.to"
                         class="solis-menu__item" active-class="solis-menu__item--active">
                <v-list-item-icon class="mr-3">
                    <v-icon size="20">{{ page.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>{{ page.name }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <!-- Item com filhos -->
            <v-list-group v-else :key="'g-'+i" class="solis-menu__group" active-class="solis-menu__group--active"
                          :prepend-icon="page.icon">
                <template v-slot:activator>
                    <v-list-item-content>
                        <v-list-item-title>{{ page.name }}</v-list-item-title>
                    </v-list-item-content>
                </template>

                <v-list-item v-for="(childPage, j) in page.children" :key="j" :to="childPage.to"
                             class="solis-menu__child" active-class="solis-menu__item--active">
                    <v-list-item-icon class="mr-3">
                        <v-icon size="16">{{ childPage.icon }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>{{ childPage.name }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list-group>
        </template>
    </v-list>
</template>

<script>
export default {
    name: "menubar",
    data: function () {
        return {
            nodes: [
                // Solis: InicioIcon
                { name: "Início", icon: "mdi-home-outline", children: [], to: "/bemvindo" },
                { name: "Dashboard", icon: "mdi-view-dashboard-outline", children: [], to: "/dashboard" },
                {
                    // Solis: PlacasolarIcon
                    name: 'Balanço Energético', icon: "mdi-solar-power-variant-outline",
                    children: [
                        { name: 'Setup', to: "/controle-balanco", icon: "mdi-cog-outline" },
                        { name: 'Visualização', to: "/visualizar-balanco", icon: "mdi-calendar-month-outline" },
                        { name: 'Falhas', to: "/erros-balanco-ano", icon: "mdi-alert-circle-outline" },
                        { name: 'Resultados', to: "/tipos-resultado", icon: "mdi-format-list-checks" },
                        { name: 'Conformidade', to: "/testes-conformidade", icon: "mdi-shield-check-outline" },
                    ],
                },
                {
                    name: 'Unidades Geradoras', icon: "mdi-flash-outline",
                    children: [
                        { name: 'Setup', to: "/fazendas-setup", icon: "mdi-cog-outline" },
                        { name: 'Visualização', to: "/fazendas-ano", icon: "mdi-flash-outline" },
                    ]
                },
                {
                    // Solis: EconomiaIcon / FaturaIcon
                    name: 'Balanço Financeiro', icon: "mdi-cash-multiple",
                    children: [
                        { name: 'Pré Faturas', to: "/listagem-pre-fatura", icon: "mdi-receipt-outline" },
                        { name: 'Descontos', to: "/descontos-extraordinarios", icon: "mdi-tag-outline" },
                        { name: 'Faturas', to: "/faturas", icon: "mdi-receipt-text-check-outline" },
                        { name: 'Falhas', to: "/erros-financeiro", icon: "mdi-alert-circle-outline" },
                    ],
                },
                {
                    name: 'Concessionárias', icon: "mdi-transmission-tower-export",
                    children: [
                        { name: 'Setup', to: "/concessionarias-setup", icon: "mdi-domain" },
                        { name: 'Tarifas', to: "/grupos-tarifarios", icon: "mdi-tag-multiple-outline" },
                    ],
                },
                {
                    name: "Tradutores", icon: "mdi-translate",
                    children: [
                        { name: "Tradutor", to: "/tradutores", icon: "mdi-swap-horizontal" },
                        { name: "Painel", to: "/tradutores-painel", icon: "mdi-table" },
                    ],
                },
                {
                    name: "Dados", icon: "mdi-database-outline",
                    children: [
                        { name: "Monitoramento", to: "/monitoramento-faturas", icon: "mdi-chart-line" },
                        { name: "Carregar Dados", to: "/formulario-faturas-distribuidoras", icon: "mdi-upload" },
                    ]
                },
                // Solis: DescritivoIcon
                { name: "Relatórios", icon: "mdi-file-document-outline", to: "/relatorios", children: [] },
            ],
        }
    }
}
</script>

<style scoped>
.solis-menu {
    background: transparent !important;
}

.solis-menu__item,
.solis-menu__child {
    color: rgba(255, 255, 255, 0.85) !important;
    border-radius: 6px;
    margin-bottom: 2px;
    min-height: 40px;
    transition: all 0.2s ease;
}

.solis-menu__item:hover,
.solis-menu__child:hover {
    background: rgba(255, 255, 255, 0.1) !important;
}

.solis-menu__item--active {
    background: rgba(255, 255, 255, 0.15) !important;
    color: #FFFFFF !important;
}

.solis-menu__item .v-list-item__icon .v-icon,
.solis-menu__child .v-list-item__icon .v-icon {
    color: rgba(255, 255, 255, 0.7) !important;
}
.solis-menu__item--active .v-list-item__icon .v-icon {
    color: #FFFFFF !important;
}

.solis-menu__item .v-list-item__title,
.solis-menu__child .v-list-item__title {
    color: rgba(255, 255, 255, 0.85) !important;
    font-size: 13px;
    font-weight: 500;
}
.solis-menu__item--active .v-list-item__title {
    color: #FFFFFF !important;
    font-weight: 700;
}

.solis-menu__child {
    padding-left: 28px !important;
    min-height: 36px;
}
.solis-menu__child .v-list-item__title {
    font-size: 12px !important;
}

.solis-menu__group >>> .v-list-group__header {
    color: rgba(255, 255, 255, 0.85) !important;
    border-radius: 6px;
    min-height: 40px;
    margin-bottom: 2px;
}
.solis-menu__group >>> .v-list-group__header:hover {
    background: rgba(255, 255, 255, 0.1) !important;
}
.solis-menu__group >>> .v-list-group__header .v-icon {
    color: rgba(255, 255, 255, 0.7) !important;
}
.solis-menu__group--active >>> .v-list-group__header .v-icon {
    color: #FFFFFF !important;
}
.solis-menu__group >>> .v-list-group__header .v-list-item__title {
    color: rgba(255, 255, 255, 0.85) !important;
    font-size: 13px;
    font-weight: 500;
}
.solis-menu__group--active >>> .v-list-group__header .v-list-item__title {
    color: #FFFFFF !important;
    font-weight: 700;
}
</style>



// WEBPACK FOOTER //
// src/components/menubar.vue